<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Edit Payment</h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton v-if="isEdit" danger class="ml-auto md:ml-4" @click="isEdit = false">
              Delete
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <div v-if="initialized" class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <PaymentForm
          v-if="isEdit"
          :default-data="defaultData"
          :issuer-options="issuerOptions"
          :account-relation-options-by-issuer="accountRelationOptionsByIssuer"
          :payment-account-options-by-issuer="paymentAccountOptionsByIssuer"
          :disabled="isLoading"
          @payment-form:submit="doUpdate"
        />
        <PaymentDelete
          v-else
          :payment-uuid="defaultData.uuid"
          @payment-delete:cancel="isEdit = true"
          @payment-delete:deleted="doGoBack"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { paymentsClient } from '@/api/clients/admin';
import PaymentDeleteVue from '@/components/Payments/PaymentDelete.vue';
import PaymentFormVue from '@/components/Payments/PaymentForm.vue';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  name: 'PaymentPage',

  components: {
    PaymentForm: PaymentFormVue,
    PaymentDelete: PaymentDeleteVue,
  },

  props: {
    paymentUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      initialized: false,
      status: STATUS_IDLE,
      defaultData: {},
      issuerOptions: [],
      accountRelationOptionsByIssuer: [],
      paymentAccountOptionsByIssuer: [],
      serverErrors: null,
      errorMessage: '',
      isEdit: true,
    };
  },

  computed: {
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const response = await paymentsClient.edit(to.params.paymentUuid);

      next((vm) => {
        vm.setData(response.data);
      });
    } catch (error) {
      next(false);
    }
  },

  methods: {
    ...mapActions('admin/payments', {
      updatePayment: 'update',
    }),
    setData({ data = {}, issuers = [], clients = [], paymentAccounts = [] } = {}) {
      this.defaultData = {
        ...data,
      };
      this.issuerOptions = issuers;
      this.accountRelationOptionsByIssuer = clients;
      this.paymentAccountOptionsByIssuer = paymentAccounts;
      this.initialized = true;
    },

    async doUpdate(formData) {
      if (this.isLoading) return;

      this.errorMessage = '';
      this.status = STATUS_PENDING;

      try {
        await this.updatePayment({ paymentUuid: this.paymentUuid, formData });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;

        if (!error.response) {
          this.errorMessage = 'Something went wrong. Try again later';
        }

        if (error.response.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.serverErrors = error.response.data.errors;
          this.errorMessage = error.response.data.message;
        }
      }
    },

    doGoBack() {
      this.$router.back();
    },
  },
};
</script>
